import { getEnabledElement } from '@cornerstonejs/core';
import { BaseTool } from './base';
class ZoomToolMouseWheelTool extends BaseTool {
    constructor(toolProps = {}, defaultToolProps = {
        supportedInteractionTypes: ['Mouse', 'Touch'],
        configuration: {
            zoomToCenter: false,
            minZoomScale: 0.1,
            maxZoomScale: 30,
            invert: false,
        },
    }) {
        super(toolProps, defaultToolProps);
    }
    mouseWheelCallback(evt) {
        const { wheel, element } = evt.detail;
        const { spinY } = wheel;
        const { invert, maxZoomScale, minZoomScale } = this.configuration;
        const enabledElement = getEnabledElement(element);
        const { viewport } = enabledElement;
        const zoomSpeedMultiplier = 15;
        const delta = invert
            ? spinY * zoomSpeedMultiplier
            : -spinY * zoomSpeedMultiplier;
        const camera = viewport.getCamera();
        const { parallelScale, focalPoint, position } = camera;
        const size = [element.clientWidth, element.clientHeight];
        const zoomScale = 1.5 / size[1];
        const k = delta * zoomScale * (this.configuration.invert ? -1 : 1);
        const parallelScaleToSet = (1.0 - k) * parallelScale;
        const focalPointToSet = focalPoint;
        const positionToSet = position;
        const imageData = viewport.getImageData();
        let spacing = [1, 1, 1];
        if (imageData) {
            spacing = imageData.spacing;
        }
        const t = element.clientHeight * spacing[1] * 0.5;
        const scale = t / parallelScaleToSet;
        let cappedParallelScale = parallelScaleToSet;
        let thresholdExceeded = false;
        if (imageData) {
            if (scale < minZoomScale) {
                cappedParallelScale = t / minZoomScale;
                thresholdExceeded = true;
            }
            else if (scale >= maxZoomScale) {
                cappedParallelScale = t / maxZoomScale;
                thresholdExceeded = true;
            }
        }
        viewport.setCamera({
            parallelScale: cappedParallelScale,
            focalPoint: thresholdExceeded ? focalPoint : focalPointToSet,
            position: thresholdExceeded ? position : positionToSet,
        });
        enabledElement.viewport.render();
    }
}
ZoomToolMouseWheelTool.toolName = 'ZoomToolMouseWheel';
export default ZoomToolMouseWheelTool;
//# sourceMappingURL=ZoomToolMouseWheelTool.js.map